import { notifications } from "@mantine/notifications";

export function notifySuccess(title: string, message?: string) {
	notifications.show({
		title,
		message: message ?? "",
		color: "success",
	});
}

export function notifyError(title: string, message?: string) {
	notifications.show({
		title,
		message: message ?? "",
		color: "danger",
	});
}
